import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class TwitterShare extends PureComponent {
    constructor(props) {
        super(props);
    }
    tweetItOut = () => {
        var link = this.props.url == null ? window.location.href : this.props.url;
        var url = 'https://twitter.com/share/';
        url += `?url=${ link }&related=DesireList`;

        var width  = 575,
        height = 400,
        left   = (window.innerWidth - width)  / 2,
        top    = (window.innerHeight - height) / 2,
        opts   = 'status=1' +
        ',width='  + width  +
        ',height=' + height +
        ',top='    + top    +
        ',left='   + left;

        window.open(url, 'twitter', opts);

        if( this.props.trackShare ) {
            this.props.trackShare( 'twitter' );
        }
    }
    render() {
        return (
            <div className={ style.twitterShare } onClick={ this.tweetItOut } style={ this.props.style } >
                <Icon source='fontAwesome' icon='fab/faTwitter' alt='Twitter Share' size={ null } />
            </div>
        );
    }
}
TwitterShare.defaultProps = {
    url: null,
};
TwitterShare.propTypes = {
    url: PropTypes.string,
};


export default connect()( TwitterShare );
